import React, { useState, useMemo, useEffect } from 'react'
import { usePaletteTheme } from '../../../context/paletteTheme'
import ScreenerTable from './ScreenerTable'
import { Button, Avatar, Chip, Container, SvgIcon } from '@mui/material'
import ScreenerFiltersModal from './ScreenerFiltersModal'
import { ScreenersContextProvider, useScreenersContext } from '../context/useScreenersContext'
import { ScreenerContextProvider, useScreenerContext} from '../context/useScreenerContext'
import InlineEdit from '../../InlineEdit'
import { FilterList } from '@mui/icons-material'
import ScreenerEditColumnsModal from './ScreenerEditColumnsModal'
import MyScreensDropdown from './MyScreensDropdown'
import usePrevious from '../../../hooks/usePrevious'
import styles from './Screener.module.scss'

const checkIfChangeSelectedScreener = (state, prevState, selectedScreener) => 
    prevState.length < state.length || !state.find(screener => screener.uuid === selectedScreener)


const Screeners = () => {
    const [ selectedScreener, setSelectedScreener ] = useState('')
    const [ selectOptions, setSelectedOptions ] = useState() 
    const { screeners } = useScreenersContext()

    const prevScreeners = usePrevious(screeners) ?? []

    useEffect(() => {
        checkIfChangeSelectedScreener(screeners, prevScreeners, selectedScreener) && setSelectedScreener('')
        setSelectedOptions(screeners.map(screener => ({value: screener.uuid, name: screener.name})))
        return () => {}
    } ,[screeners])  // eslint-disable-line

    useEffect(() => {
        !selectedScreener && selectOptions?.length && setSelectedScreener(selectOptions[0].value)
        return () => {}
    }, [selectOptions, selectedScreener])

    const screenerData = useMemo(() => selectedScreener && 
        <ScreenerContextProvider {...screeners.find(screener => screener.uuid === selectedScreener)} >
            <Screener/> 
        </ScreenerContextProvider>
    ,[selectedScreener, screeners])

    return (
        <Container maxWidth="xl" classes={{root: styles['tab-conatiner']}}>
            <MyScreensDropdown selectedScreener={selectedScreener} setSelectedScreener={setSelectedScreener}/>
            {screenerData}
        </Container>
    )
}

const Screener = () => {
    const [ open, setOpen ] = useState(false)
    const [ openEditColumn, setOpenEditColumn ] = useState(false)
    const { handleUpdateFilters, columns, handleUpdateScreenerName, name, data, isLoading, isEmpty, chips, handleRemoveFilter, handleUpdateColumns } = useScreenerContext()

    const [loader, setloader] = useState(false)

    const openFiltersModal = () => setOpen(true)

    const closeFilterModal = (type='cancel') =>{setOpen(false);type=='cancel'?setloader(false):setloader(true)}

    const openEditColumnsModal = () => setOpenEditColumn(true)

    const closeEditColumnsModal = () => setOpenEditColumn(false)

    useEffect(()=>{
        if (!isLoading){
            setloader(false)
        }
        return () =>{}
    },[isLoading])

    useEffect(()=>{
        if (chips && !data.length){
            setloader(true)
        }
    },[chips])


    const chipsComponent = useMemo(() => (<div className={styles['chips']}>
        {chips.map(item => <Chip key={item?.name}
                avatar={<Avatar classes={{root: styles['inner-avatar']}}>{item?.name}</Avatar>}
                label={<div>
                        {(item?.value.slice(0,2)).join(', ')}
                        {item?.value.length > 2 && <div className={styles['chip-label-button']}>+{item?.value.length - 2}</div>}
                    </div>}
                classes={{root: styles['chip'], label: styles['chip-label']}}
                onDelete={() => handleRemoveFilter(item.key,item.value)}
            />
        )}
        </div>
    ),[chips, handleRemoveFilter]) 

    return(
            <>
                <div className={styles['screener']}>
                    <div>
                        <InlineEdit extraClassname={styles['inline-edit']} text={name} onSetText={handleUpdateScreenerName} maxLength={95} fontSize={24}/>
                        <div>
                            {data?.length ? <Button color="secondary"  size="small" variant="contained" onClick={openEditColumnsModal} startIcon={<EditColumnsIcon/>}>
                                Edit columns
                            </Button> : <></>}
                            <Button size="small" color="secondary" variant="contained" classes={{root: styles[!isEmpty ? 'filters-active' : '']}} onClick={openFiltersModal} startIcon={<FilterList/>}>
                                Filters
                            </Button>
                        </div>
                    </div>
                    {chipsComponent}
                    <ScreenerTable columns={columns} rows={data} isLoading={loader} isEmpty={isEmpty}/>
                </div>
                <ScreenerFiltersModal open={open} handleClose={closeFilterModal} title={name} handleUpdateFilters={handleUpdateFilters}/>
                <ScreenerEditColumnsModal open={openEditColumn} handleClose={closeEditColumnsModal} title='Edit columns' columns={columns} handleUpdateColumns={handleUpdateColumns}/>
            </>
    )
}

const EditColumnsIcon = () => {
    const { colors } = usePaletteTheme()
    return (
        <SvgIcon>
            <svg width="20" height="25" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.33333 1.33325H1V14.6666H4.33333V1.33325Z" stroke={colors.textSecondary} strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M11 1.33325H7.66667V14.6666H11V1.33325Z" stroke={colors.textSecondary} strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        </SvgIcon>
    )
}

const ScreenersTab = () => {
    return (
        <ScreenersContextProvider>
            <Screeners/>
        </ScreenersContextProvider>
    )
}

export default ScreenersTab